import { render, staticRenderFns } from "./addView.vue?vue&type=template&id=a66d4598&scoped=true"
import script from "./addView.vue?vue&type=script&lang=js"
export * from "./addView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66d4598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a66d4598')) {
      api.createRecord('a66d4598', component.options)
    } else {
      api.reload('a66d4598', component.options)
    }
    module.hot.accept("./addView.vue?vue&type=template&id=a66d4598&scoped=true", function () {
      api.rerender('a66d4598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/doorplateManage/addView.vue"
export default component.exports